const en = {
  nav: {
    about: 'About',
    services: 'Services',
    regions: 'Regions',
    whyUs: 'Why Us',
    contact: 'Contact',
    getStarted: 'Get Started',
  },
  hero: {
    heading: 'International Business Consulting & Trade Connections',
    paragraph: 'Connecting businesses across Europe, Middle East, Central Asia, and Estonia through strategic partnerships and market expertise.',
    contactButton: 'Contact Us',
    learnButton: 'Learn More',
  },
  about: {
    badge: 'About TS Consulting',
    heading: 'Building Bridges Across Continents',
    paragraph: 'TS Consulting specializes in creating reliable business relationships and establishing international contacts. We support cross-border cooperation between Europe, the Middle East, Central Asia, and Estonia, helping companies navigate complex international markets with confidence and expertise.',
  },
  services: {
    heading: 'Our Services',
    subtitle: 'Comprehensive solutions for international business growth.',
    card1Title: 'Business Networking',
    card1Description: 'Connect with verified partners across multiple regions and industries through our extensive network.',
    card2Title: 'Trade Facilitation',
    card2Description: 'Navigate customs, regulations, and logistics with expert guidance for seamless cross-border trade.',
    card3Title: 'International Market Connections',
    card3Description: 'Access market insights and establish presence in Europe, Middle East, and Central Asia.',
    card4Title: 'Strategic Investments',
    card4Description: 'Strategic investments in real estate and manufacturing, focused on developing modern production facilities.',
    learnMore: 'Learn more →',
  },
  regions: {
    badge: 'Global Reach',
    heading: 'Regions We Serve',
    europe: 'Europe',
    europeSubtitle: 'Business partnerships and consulting',
    middleEast: 'Middle East',
    middleEastSubtitle: 'Trade and cooperation networks',
    estonia: 'Estonia',
    estoniaSubtitle: 'Baltic business hub',
    egypt: 'Egypt',
    egyptSubtitle: 'Regional market connections',
    centralAsia: 'Central Asia',
    centralAsiaSubtitle: 'Cross-border business opportunities',
  },
  whyUs: {
    heading: 'Why Choose TS Consulting',
    reason1Title: 'International Business Network',
    reason1Description: 'Access to verified partners and decision-makers across five strategic regions.',
    reason2Title: 'Regional Market Understanding',
    reason2Description: 'Deep knowledge of local business cultures, regulations, and market dynamics.',
    reason3Title: 'Reliable Partnerships',
    reason3Description: 'Long-term relationships built on trust, transparency, and proven results.',
    reason4Title: 'Personal Consulting Approach',
    reason4Description: 'Dedicated consultants who understand your specific business needs and goals.',
  },
  partners: {
    heading: 'Strategic Partners',
    description: 'We collaborate with trusted organizations across Europe, the Middle East, and Central Asia to support international business development and cross-border cooperation.',
    supportText: 'We work with carefully selected partners who share our commitment to reliability, transparency, and long-term cooperation.',
  },
  contact: {
    card1Heading: 'Get In Touch',
    card1Paragraph: 'Ready to expand your business internationally? Let\'s discuss partnership opportunities.',
    card2Heading: 'Start Your International Journey',
    card2Paragraph: 'Whether you\'re looking to enter new markets, find reliable partners, or navigate international trade complexities, TS Consulting provides the expertise and connections you need.',
    scheduleButton: 'Schedule Consultation',
    responseText: 'Response within 24 hours',
  },
  footer: {
    aboutHeading: 'About Us',
    aboutText: 'Connecting businesses across continents through strategic partnerships and expert market knowledge.',
    quickLinks: 'Quick Links',
    link1: 'Business Networking',
    link2: 'Trade Services',
    link3: 'Market Entry',
    link4: 'Consulting',
    link5: 'Resources',
    copyright: '© 2026 TS Consulting. All rights reserved.',
    privacyPolicy: 'Privacy Policy',
    termsOfService: 'Terms of Service',
    cookiePolicy: 'Cookie Policy',
  },
  privacyPolicy: {
    title: 'Privacy Policy',
    lastUpdated: 'Last Updated: January 2025',
    introTitle: 'Introduction',
    introText: 'TS Consulting ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or use our services.',
    infoCollectTitle: 'Information We Collect',
    infoCollectText: 'We collect information that you provide directly to us, including name, email address, phone number, company name, and any other information you choose to provide. We also automatically collect certain information about your device when you use our website, including IP address, browser type, and usage data.',
    howUseTitle: 'How We Use Your Information',
    howUseText: 'We use the information we collect to provide, maintain, and improve our services; communicate with you about our services; respond to your inquiries; send you marketing communications (with your consent); and comply with legal obligations.',
    dataProtectionTitle: 'Data Protection',
    dataProtectionText: 'We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the internet is 100% secure.',
    dataSharingTitle: 'Data Sharing and Disclosure',
    dataSharingText: 'We do not sell your personal information. We may share your information with service providers who assist us in operating our website and conducting our business, professional advisors, and as required by law or to protect our rights.',
    cookiesTitle: 'Cookies and Tracking Technologies',
    cookiesText: 'We use cookies and similar tracking technologies to track activity on our website and hold certain information. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent.',
    userRightsTitle: 'Your Rights',
    userRightsText: 'Depending on your location, you may have certain rights regarding your personal information, including the right to access, correct, delete, or restrict the processing of your personal data. To exercise these rights, please contact us using the information provided below.',
    dataRetentionTitle: 'Data Retention',
    dataRetentionText: 'We retain your personal information for as long as necessary to fulfill the purposes outlined in this Privacy Policy, unless a longer retention period is required or permitted by law.',
    internationalTitle: 'International Data Transfers',
    internationalText: 'Your information may be transferred to and maintained on computers located outside of your country where data protection laws may differ. By using our services, you consent to this transfer.',
    changesTitle: 'Changes to This Privacy Policy',
    changesText: 'We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last Updated" date.',
    contactTitle: 'Contact Us',
    contactText: 'If you have any questions about this Privacy Policy, please contact us at: info@tsconsulting.ee',
  },
  termsOfService: {
    title: 'Terms of Service',
    lastUpdated: 'Last Updated: January 2025',
    introTitle: 'Introduction',
    introText: 'Welcome to TS Consulting. By accessing or using our website and services, you agree to be bound by these Terms of Service. If you do not agree with any part of these terms, you may not access our services.',
    purposeTitle: 'Use of Our Website',
    purposeText: 'Our website is intended to provide information about our consulting services and facilitate business inquiries. You agree to use our website only for lawful purposes and in accordance with these Terms. You may not use our website in any way that could damage, disable, or impair our services.',
    intellectualTitle: 'Intellectual Property',
    intellectualText: 'All content on this website, including text, graphics, logos, images, and software, is the property of TS Consulting or its content suppliers and is protected by international copyright laws. You may not reproduce, distribute, or create derivative works from our content without express written permission.',
    limitationTitle: 'Limitation of Liability',
    limitationText: 'TS Consulting shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of or inability to use our services. Our total liability shall not exceed the amount paid by you, if any, for accessing our services.',
    externalTitle: 'External Links',
    externalText: 'Our website may contain links to third-party websites. We are not responsible for the content, privacy policies, or practices of any third-party sites. We encourage you to review the terms and policies of any third-party websites you visit.',
    changesTitle: 'Changes to Terms',
    changesText: 'We reserve the right to modify these Terms of Service at any time. Changes will be effective immediately upon posting to the website. Your continued use of our services after changes are posted constitutes acceptance of the modified terms.',
    governingTitle: 'Governing Law',
    governingText: 'These Terms shall be governed by and construed in accordance with applicable international business law, without regard to its conflict of law provisions.',
    contactTitle: 'Contact Us',
    contactText: 'If you have any questions about these Terms of Service, please contact us at: info@tsconsulting.ee',
  },
  cookiePolicy: {
    title: 'Cookie Policy',
    lastUpdated: 'Last Updated: January 2025',
    whatAreTitle: 'What Are Cookies',
    whatAreText: 'Cookies are small text files that are placed on your device when you visit a website. They are widely used to make websites work more efficiently and provide information to website owners.',
    howUseTitle: 'How We Use Cookies',
    howUseText: 'We use cookies to understand how you use our website, remember your preferences, improve your experience, and analyze website traffic. Cookies help us provide you with a better and more personalized service.',
    typesTitle: 'Types of Cookies We Use',
    essentialTitle: 'Essential Cookies',
    essentialText: 'These cookies are necessary for the website to function properly. They enable basic functions like page navigation and access to secure areas of the website.',
    analyticsTitle: 'Analytics Cookies',
    analyticsText: 'These cookies help us understand how visitors interact with our website by collecting and reporting information anonymously. We use this data to improve our website performance.',
    functionalTitle: 'Functional Cookies',
    functionalText: 'These cookies enable enhanced functionality and personalization, such as remembering your language preference and other customization options.',
    managingTitle: 'Managing Cookies',
    managingText: 'Most web browsers allow you to control cookies through their settings. You can set your browser to refuse cookies or delete certain cookies. However, if you disable cookies, some features of our website may not function properly.',
    updatesTitle: 'Updates to This Policy',
    updatesText: 'We may update this Cookie Policy from time to time to reflect changes in technology or legal requirements. Please review this page periodically for any updates.',
    contactTitle: 'Contact Us',
    contactText: 'If you have any questions about our use of cookies, please contact us at: info@tsconsulting.ee',
  },
};

export default en;